import { CreateTendon } from './create-tendon.js';
import { uuidV4 } from '../util/others/uuid-v4.js';

/** Link two joints with a bone. The id of the bone is created internally */
function CreateBone(partialBone) {
    if (partialBone.joints?.length !== 2)
        throw new Error('Bone needs 2 joints');
    const bone = {
        ...partialBone,
        id: uuidV4(),
        tendon: { ...CreateTendon(partialBone.joints), ...partialBone.tendon }
    };
    partialBone.joints[0].bones.push(bone);
    partialBone.joints[1].bones.push(bone);
    return bone;
}

export { CreateBone };
//# sourceMappingURL=create-bone.js.map
